module.exports = __webpack_public_path__ + "img/drt5.4cc96c87.png";